import React from "react";
import moment from "moment";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import LinkIcon from "@mui/icons-material/Link";
import LoginIcon from "@mui/icons-material/Login";
import { useSelector } from "react-redux";
import "./Footer.css";

const Footer = () => {
  const { activeSession } = useSelector(({ auth }) => auth);

  return (
    <div className="footer">
      <div className="top">
        <div className="left">
          <div className="title">PHYSICAL ADDRESS</div>
          <div className="physical-address">
            <ul>
              <li>Bank Of Tanzania</li>
              <li>2 Mirambo Street</li>
              <li>P.O Box 2939</li>
              <li>11884 Dar es salaam - Tanzania</li>
              <li>
                Tel: <LocalPhoneIcon />{" "}
                <a href="tel:+255 26 2963182">+255 26 2963182</a>
              </li>
              <li>
                Toll free phone no <LocalPhoneIcon /> <a href="tel:"></a>
              </li>
              <li>
                Email: <EmailIcon />{" "}
                <a href="email:tz-fincert@bot.go.tz">tz-fincert@bot.go.tz</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="right">
          <div className="title">Quick Links </div>
          <ul className="quick-links">
            <li className="link-item">
              <LinkIcon />
              <a target="_blank" href="https://www.africacert.org/">
                AfricaCERT
              </a>
            </li>
            <li className="link-item">
              <LinkIcon />
              <a target="_blank" href="https://www.tzcert.go.tz/">
                TZ-CERT
              </a>
            </li>
            <br />
            {(activeSession?.session_token === null ||
              activeSession?.session_token === undefined) && (
              <li className="link-item">
                <LoginIcon />
                <a href="/login">Login</a>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="bottom">
        &copy; Bank of Tanzania {moment().format("YYYY")}, All rights reserved
      </div>
    </div>
  );
};

export default Footer;
